import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail } from "lucide-react";
import { LogoMark } from "./Logo";

const COLS = [
  {
    title: "Explore",
    links: [
      { to: "/vision", label: "The Vision" },
      { to: "/experience", label: "The Experience" },
      { to: "/story", label: "Our Story" },
      { to: "/journal", label: "Journal" },
    ],
  },
  {
    title: "Connect",
    links: [
      { to: "/contact", label: "Contact" },
      { to: "/contact", label: "Partnerships" },
      { to: "/privacy", label: "Privacy Policy" },
      { to: "/terms", label: "Terms of Use" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="relative border-t border-white/10 bg-rp-bg" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-12 md:py-24">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <LogoMark size={40} />
              <span className="font-display text-2xl font-bold tracking-tight text-white">
                REST<span className="text-rp-accent">POWER</span>
              </span>
            </div>
            <p className="mt-6 max-w-sm font-display text-xl font-light tracking-tight text-white/70">
              More Than a Charge. It's a Better Stop.
            </p>
            <a
              href="mailto:info@restpower.app"
              className="mt-6 inline-flex items-center gap-2 font-mono text-sm text-white/60 transition-colors hover:text-rp-accent"
              data-testid="footer-email"
            >
              <Mail className="h-4 w-4" /> info@restpower.app
            </a>
          </div>

          <div className="grid grid-cols-2 gap-8 md:col-span-5">
            {COLS.map((col) => (
              <div key={col.title}>
                <h4 className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/40">{col.title}</h4>
                <ul className="mt-5 space-y-3">
                  {col.links.map((l, i) => (
                    <li key={`${l.to}-${i}`}>
                      <Link
                        to={l.to}
                        className="text-sm text-white/70 transition-colors duration-200 hover:text-rp-accent"
                        data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="md:col-span-2">
            <h4 className="font-mono text-[11px] uppercase tracking-[0.18em] text-white/40">Follow</h4>
            <div className="mt-5 flex gap-3">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram"
                className="grid h-11 w-11 place-items-center rounded-full border border-white/12 text-white/70 transition-colors duration-200 hover:border-rp-accent hover:text-rp-accent">
                <Instagram className="h-5 w-5" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" data-testid="social-linkedin"
                className="grid h-11 w-11 place-items-center rounded-full border border-white/12 text-white/70 transition-colors duration-200 hover:border-rp-accent hover:text-rp-accent">
                <Linkedin className="h-5 w-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 md:flex-row md:items-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-white/35">
            © {new Date().getFullYear()} RestPower. All rights reserved.
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-white/35">
            Early-stage · In development · restpower.app
          </p>
        </div>
      </div>
    </footer>
  );
}
